import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { PublicShell } from "@/components/PublicNav";
import { SEO } from "@/components/SEO";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/blogs/${slug}`).then(({ data }) => {
      setPost(data);
    }).catch(() => setError("Post not found"));
  }, [slug]);

  if (error)
    return (
      <PublicShell>
        <div className="zq-section text-center">
          <p className="text-zq-muted">{error}</p>
          <Link to="/blog" className="zq-btn zq-btn-outline mt-4 inline-flex">Back to blog</Link>
        </div>
      </PublicShell>
    );
  if (!post)
    return (
      <PublicShell>
        <div className="zq-section text-center text-zq-muted">Loading…</div>
      </PublicShell>
    );

  return (
    <PublicShell>
      <SEO
        title={`${post.seo_title || post.title} — ZaykaQR`}
        description={post.seo_description || post.excerpt}
        image={post.featured_image}
        url={`https://zaykaqr.space/blog/${post.slug}`}
        type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": post.title,
          "image": post.featured_image ? [post.featured_image] : undefined,
          "datePublished": post.created_at,
          "author": { "@type": "Person", "name": post.author },
          "publisher": { "@type": "Organization", "name": "ZaykaQR" },
          "description": post.seo_description || post.excerpt,
          "keywords": post.seo_keywords,
        }}
      />
      <article className="max-w-3xl mx-auto px-5 md:px-8 py-12">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-zq-muted hover:text-zq-orange" data-testid="blog-back">
          <ArrowLeft size={16} /> Back to blog
        </Link>
        <h1 className="text-3xl md:text-5xl font-bold mt-5">{post.title}</h1>
        <div className="text-sm text-zq-muted mt-3">
          {post.author} · {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
        </div>
        {post.featured_image && (
          <img src={post.featured_image} alt={post.title} className="w-full rounded-xl mt-7" />
        )}
        <div className="prose prose-neutral max-w-none mt-8 text-base whitespace-pre-line leading-relaxed text-zq-charcoal">
          {post.content}
        </div>
      </article>
    </PublicShell>
  );
};
